// extracted by mini-css-extract-plugin
module.exports = {"submit--position":"ResetReq_submit--position__1fGDi"};